import type { HelpFile } from '../../types/help'
import { RecentNotificationsTestIds } from '../../../testids/RecentNotificationsTestIds'

export const recentNotificationsHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [RecentNotificationsTestIds.recentNotificationsCard]: null,
    [RecentNotificationsTestIds.cardTitleRecentNotifications]: 'Recent events relevant to you — access changes, approval activity, and provisioning status.',
    [RecentNotificationsTestIds.dashboardViewAllNotifications]: 'Open the full notification log to browse and filter all received notifications.',
  },
}
